export default __webpack_public_path__ + "static/media/shoppage-package2.b8a89afa.svg";